import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';

export type DeleteDocumentsRequest = {
    id: string;
    keepReferences: boolean;
}[];

async function deleteDocuments(request: DeleteDocumentsRequest): Promise<void> {
    await api.delete('/file-records', { data: request });
}

export function useDeleteDocuments(): UseMutationResult<void, unknown, DeleteDocumentsRequest, unknown> {
    return useMutation(deleteDocuments, {
        onSettled: () => {
            queryClient.invalidateQueries(['file-records']);
        },
    });
}
